import { Component, DestroyRef, EventEmitter, inject, Input, Output } from '@angular/core';
import { AvatarComponent } from 'app/shared/avatar/avatar.component';
import { IconComponent } from 'app/shared/icon/icon.component';
import { NgIf } from '@angular/common';
import { ContactEvent, IContact } from '../model/friends.model';
import { FriendsService } from '../service/friends.service';
import { MatButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { provideIcons, provideNgIconLoader, withCaching } from '@ng-icons/core';
import { heroEllipsisHorizontal } from '@ng-icons/heroicons/outline';
import { DialogService } from 'app/shared/dialog/dialog.service';
import { ConfirmEmailDialogComponent } from 'app/shared/dialog/confirm-email-dialog/confirm-email-dialog.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpClient } from "@angular/common/http";

@Component({
  selector: 'app-contact-card',
  standalone: true,
  imports: [AvatarComponent, IconComponent, NgIf, MatButton, MatMenu, MatMenuItem, MatMenuTrigger],
  templateUrl: './contact-card.component.html',
  styleUrls: ['./contact-card.component.scss'],
  providers: [
    provideIcons({
      heroEllipsisHorizontal,
    }),
    provideNgIconLoader((name) => {
      const http = inject(HttpClient);
      return http.get(`/assets/icons/${name}.svg`, { responseType: 'text' });
    }, withCaching()),
  ],
})
export class ContactCardComponent {
  @Input() contact!: IContact;
  @Output() eventTriggered = new EventEmitter();
  private dialogService = inject(DialogService);
  private destroyRef = inject(DestroyRef);
  friendsService = inject(FriendsService);

  onMenuClick(event: Event): void {
    event.stopPropagation();
  }

  addEmail(): void {
    this.dialogService
      .open(ConfirmEmailDialogComponent)
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((email: string) => {
        if (!email) return;
        this.contact.email = email

        this.eventTriggered.emit({
          type: ContactEvent.Update,
          contact: this.contact
        })
      });
  }

  sendInvite(): void {
    this.eventTriggered.emit({
      type: ContactEvent.Invite,
      contact: this.contact,
    });
  }

  removeFromList(): void {
    this.eventTriggered.emit({
      type: ContactEvent.Removed,
      contact: this.contact
    });
  }
}
